import React from 'react';
import Story from '../../models/Story';

interface StoriesContext {
  stories: Story[];
  queryKey: unknown[];
}

export const StoriesContext = React.createContext<StoriesContext>({ stories: [], queryKey: [] });

export const useStoriesContext = () => {
  const context = React.useContext(StoriesContext);
  if (!context) {
    throw new Error('useStoriesContext must be used within a StoriesProvider');
  }
  return context;
};
